import products from './index.js';
import moment from 'moment'


const UPDATE_PRODUCTS = (state, products) => {
  state.products = products;
};

const SET_LOADING_PRODUCTS = (state, loadingProducts)=>{
  state.loadingProducts = loadingProducts
}
const UPDATE_VENDORS= (state, vendors) => {
  state.vendors = vendors;
};

const SET_LOADING_VENDORS = (state, loadingVendors)=>{
  state.loadingVendors = loadingVendors
}

const SET_VENDOR= (state, vendor)=>{
  state.purchaseOrder.vendor = vendor;
}

const SET_PURCHASE_ORDER_PROPERTY = (state, {propName, propVal})=>{
  state.purchaseOrder[propName]=propVal;
}

const ADD_LINE = (state, line) =>{
  state.purchaseOrder.lines.push(line);
}

const SET_PRODUCT_LINE = (state, product, line) =>{
  state.purchaseOrder.lines[index].product = product;
}

const SET_LINE_PROPERTY = (state,{index, propName, propVal})=>{
  state.purchaseOrder.lines[index][propName]=propVal;
};

const REMOVE_LINE = (state, index)=>{
  state.purchaseOrder.lines.splice(index,1);
}

const RESET_STATE = state => {
  Object.assign(state, products.getDefaultState());
};

const SET_PURCHASE_ORDER = (state, {purchaseOrder, products})=>{
  Object.assign(state.purchaseOrder, purchaseOrder);
  state.purchaseOrder.reception_planning_date = purchaseOrder.reception_planning_date;
  state.purchaseOrder.shipping_delay = moment(purchaseOrder.reception_planning_date).diff(moment(purchaseOrder.date),'days');
  _.forEach(state.purchaseOrder.lines, l=>{
    const inventoryProducts = products[l.product.id];
    if (!_.isEmpty(inventoryProducts)) {
      l.productsInventory = products[l.product.id];
      const productV2 = _.head(products[l.product.id])
      l.product.uvc = productV2.uvc;
      l.product.volume = productV2.volume;
      l.product.unit = productV2.unit;
    } else {
      l.puid = null;
      l.generic_puid = l.puid;
      
    }

    l.editMarginPrice = false;
  })
}


const SET_RECEPTION_PLANNING_DATE = (state, receptionPlanningDate)=>{
  state.purchaseOrder.reception_planning_date = receptionPlanningDate;
}

const SET_SHIPPING_DELAY = (state, shippingDelay)=>{
  state.purchaseOrder.shipping_delay = shippingDelay;
}


const SET_PURCHASE_ORDER_LINE_CUSTOM_FIELD = (state, {index, customFieldIndex, customFieldValue, customFieldCode})=>{
  state.purchaseOrder.lines[index].custom_fields[customFieldIndex].value=customFieldValue;
  state.purchaseOrder.lines[index].custom_fields[customFieldIndex].code=customFieldCode;
}

const SET_PURCHASE_ORDER_LINE_PRICE = (state,{index, price})=>{
  state.purchaseOrder.lines[index].price = Math.round(price*100)/100;
}

const SET_PURCHASE_ORDER_LINE_PRICE_TAX_IN = (state,{index, price})=>{
  state.purchaseOrder.lines[index].price_tax_in = Math.round(price*100)/100;
}

const SET_MARGIN = (state, {rate, type, index}) => {
  state.purchaseOrder.lines[index].margin_rate =rate;
  state.purchaseOrder.lines[index].margin_type = type;
}

const SET_DISTINCT = (state, { distinct, index }) => {
  state.purchaseOrder.lines[index].distinct = distinct;
  if (distinct === true) {
    state.purchaseOrder.lines[index].puid = null;
  }
}

const SET_ORDERING = (state, newOrdering) => {
  const targetRow = state.purchaseOrder.lines.splice(newOrdering.oldIndex, 1)[0];
  state.purchaseOrder.lines.splice(newOrdering.newIndex, 0, targetRow);
  _.forEach(state.purchaseOrder.lines, (l, index)=>{
    l._order = index;
  })
}

const DUPLICATE = (state, purchaseOrder)=>{
  Object.assign(state.purchaseOrder, purchaseOrder);
  state.purchaseOrder.reception_planning_date = purchaseOrder.reception_planning_date;
  state.purchaseOrder.shipping_delay = moment(purchaseOrder.reception_planning_date).diff(moment(purchaseOrder.date),'days');
  state.purchaseOrder.id = null;
  state.purchaseOrder.po_number = null;
  state.purchaseOrder.status = null;
  _.forEach(state.purchaseOrder.lines, l=>{
    l.editMarginPrice = false;
  })
}

const SET_GENERIC_PUID = (state, { generic_puid, index}) => {
  state.purchaseOrder.lines[index].generic_puid = generic_puid;
}

const SET_PUID = (state, { puid, index}) => {
  state.purchaseOrder.lines[index].puid = puid;
}


export default {
  SET_DISTINCT,
  SET_GENERIC_PUID,
  SET_PUID,
  SET_ORDERING,
  UPDATE_PRODUCTS,
  SET_LOADING_PRODUCTS,
  UPDATE_VENDORS,
  SET_LOADING_VENDORS,
  SET_VENDOR,
  SET_PURCHASE_ORDER_PROPERTY,
  ADD_LINE,
  SET_PRODUCT_LINE,
  SET_LINE_PROPERTY,
  REMOVE_LINE,
  RESET_STATE,
  SET_PURCHASE_ORDER,
  SET_RECEPTION_PLANNING_DATE,
  SET_SHIPPING_DELAY,
  SET_PURCHASE_ORDER_LINE_CUSTOM_FIELD,
  SET_PURCHASE_ORDER_LINE_PRICE_TAX_IN,
  SET_PURCHASE_ORDER_LINE_PRICE,
  SET_MARGIN,
  DUPLICATE
};
